import MenuItem from '@mui/material/MenuItem';
import { MultipleIdInput } from 'common/components/Inputs/IdAdvanceSearch/MultipleIdInput';
import { useTranslation } from 'react-i18next';
import { SimId, SIM_INVENTORY_ID_SELECTION } from '../constants/sim';

export type SimIdSearchInputProps = {
  disabled?: boolean;
  chosenId: SimId;
  onChosenIdChange: (chosenId: SimId) => void;
  search: string;
  onSearchChange: (searchText: string) => void;
};

export const ID_SEARCH_LIMIT = 1000;

export const SimIdSearchInput = ({
  disabled = false,
  chosenId,
  onChosenIdChange,
  search,
  onSearchChange,
}: SimIdSearchInputProps) => {
  const { t } = useTranslation();

  return (
    <MultipleIdInput
      disabled={disabled}
      optionValue={chosenId}
      onOptionChange={onChosenIdChange as (chosenId: string) => void} // typescript cannot deduct becuase it base on menu items in children
      inputValue={search}
      onInputValueChange={onSearchChange}
      inputLabel={t('common.search')}
      selectLabel="ID"
      filterRegex={undefined}
      limit={ID_SEARCH_LIMIT}
      limitErrorMessage={t('simInventory.limitOfNRecordsExceeded', { n: ID_SEARCH_LIMIT })}
    >
      <MenuItem value={SIM_INVENTORY_ID_SELECTION.ICCID}>
        {SIM_INVENTORY_ID_SELECTION.ICCID}
      </MenuItem>
      <MenuItem value={SIM_INVENTORY_ID_SELECTION.IMSI}>{SIM_INVENTORY_ID_SELECTION.IMSI}</MenuItem>
      <MenuItem value={SIM_INVENTORY_ID_SELECTION.MSISDN}>
        {SIM_INVENTORY_ID_SELECTION.MSISDN}
      </MenuItem>
    </MultipleIdInput>
  );
};
